import { useEffect, useRef } from 'preact/hooks'

const useLightenBackground = <T extends HTMLElement>() => {
  const target = useRef<T>(null)

  useEffect(() => {
    const onMouseEnter = () => {
      if (target.current) {
        target.current.style.boxShadow = 'inset 0 0 0 10em rgba(255, 255, 255, 0.1)'
      }
    }

    const onMouseLeave = () => {
      if (target.current) {
        target.current.style.boxShadow = 'none'
      }
    }

    target.current?.addEventListener('mouseenter', onMouseEnter)
    target.current?.addEventListener('mouseleave', onMouseLeave)

    return () => {
      target.current?.removeEventListener('mouseenter', onMouseEnter)
      target.current?.removeEventListener('mouseleave', onMouseLeave)
    }
  }, [])

  return target
}

export default useLightenBackground
